import { wrapDocument, wrapDocuments, utils, __unsafe__use__it__at__your__own__risks__wrapDocument, __unsafe__use__it__at__your__own__risks__wrapDocuments } from '@tradetrust-tt/tradetrust';
export { __unsafe__use__it__at__your__own__risks__wrapDocument as wrapOADocumentV3, __unsafe__use__it__at__your__own__risks__wrapDocuments as wrapOADocumentsV3 } from '@tradetrust-tt/tradetrust';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const wrapOADocumentV2 = /* @__PURE__ */ __name(async (document) => {
  return wrapDocument(document);
}, "wrapOADocumentV2");
const wrapOADocumentsV2 = /* @__PURE__ */ __name(async (documents) => {
  return wrapDocuments(documents);
}, "wrapOADocumentsV2");
async function wrapOADocument(document) {
  if (utils.isRawV2Document(document)) {
    return wrapOADocumentV2(document);
  } else if (utils.isRawV3Document(document)) {
    return __unsafe__use__it__at__your__own__risks__wrapDocument(document);
  } else {
    throw new Error("Unsupported document version");
  }
}
__name(wrapOADocument, "wrapOADocument");
async function wrapOADocuments(documents) {
  if (documents.every((s) => utils.isRawV2Document(s))) {
    return wrapOADocumentsV2(documents);
  } else if (documents.every((s) => utils.isRawV3Document(s))) {
    return __unsafe__use__it__at__your__own__risks__wrapDocuments(documents);
  } else {
    throw new Error("Unsupported documents version");
  }
}
__name(wrapOADocuments, "wrapOADocuments");

export { wrapOADocument, wrapOADocumentV2, wrapOADocuments, wrapOADocumentsV2 };
